
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import scroll from '@/mixins/scroll';
import Address from '@/views/shelf/components/address.vue'
import { getStoreOrder } from '@/api/industryMall';
import DatetimePickerDialog from '@/views/orderManage/template/DatetimePickerDialogOrder.vue';
// import { ShopOrderInfoDto, OrderDelDTO } from "@/views/industryMall/order/order.ts";
import { Getter } from 'vuex-class';
import { Debounce } from '@/core/decorator';
import { statisticsByMoney, statisticsByGoods } from '@/api/ccx'

interface OrderParamsDTO {
  companyId: string;
  partnerCompanyId: string;
  storeId?: string;
  orderId?: string;
  receiveMobile?: string;
  goodsName?: string;
  receiveMan?: string;
  orderStatus?: number | string;
  payStatus?: number | string;
  pageSize: number;
  pageIndex: number;
}
@Component({
  name: 'SalesStatistics',
  components: {
    DatetimePickerDialog: DatetimePickerDialog,
    Address
  },
})
export default class SalesStatistics extends Mixins(scroll) {
  @Getter topSafetyHeight!: number
  @Getter partnerCompanyId!: string;
  @Getter companyId!: string;
  searchTime={
    startTime: '开始时间',
    endTime: '终止时间',
  }
//   startTime: string;
//   endTime: string;
  @Getter whiteStrips!: number;
  @Prop({ default: '' }) searchKey?: string;
  showDetail = false; // 展示明细
  error = false;
  refreshing = false;
  loading = false;
  finished = false;
  params: OrderParamsDTO = {
    companyId: '',
    partnerCompanyId: '',
    // 订单编号
    orderId: '',
    // 手机号
    receiveMobile: '',
    // 商品名称
    goodsName: '',
    // 收货人姓名
    receiveMan: '',
    pageIndex: 1,
    pageSize: 20,
  };
  moneyList = [];
  goodsList = [];
  controller: any;
  clickedItemIndex = 0;
  isActivated = false;
  dataDetail: any = {}; // 明细数据

  created () {
    this.params.partnerCompanyId = this.partnerCompanyId;
    this.params.companyId = this.companyId;
    // this.startTime = '开始时间';
    // this.endTime = '终止时间';
    this.getLastMonthDates();
    this.getMoneyList();
  }

  mounted() {
    this.$addScrollListener('.van-tabs__content');
  }

  getLastMonthDates() {
    // 获取当前日期
    const currentDate = new Date();

    // 获取上个月的第一天
    const firstDay = new Date(currentDate)
    firstDay.setMonth(currentDate.getMonth() - 1)
    // firstDay.setDate(1)
    const month = currentDate.getMonth() < 1 ? 12 : currentDate.getMonth()

    // 获取上个月的最后一天
    const lastDay = new Date(currentDate)
    lastDay.setMonth(currentDate.getMonth())
    lastDay.setDate(0)

    this.searchTime={
      startTime: `${firstDay.getFullYear()}-${month}-1`,
      endTime: lastDay.toISOString().split('T')[0],
    }
    this.getGoodsList();
  }

  openShowDetail(data: any) {
    this.showDetail = true;
    this.dataDetail = data;
  }

  closeShowDetail() {
    this.showDetail = false;
  }

  activated() {
    console.log('activated');
    if (this.isActivated) {
      // this.handleActivated();
      this.$setScrollY();
    } else {
      this.isActivated = true;
    }
  }

  deactivated() {
    this.$removeScrollListener();
  }


//   @Debounce(500)
//   handleExport(){
//     switch (this.checkType){
//       case '1':
//         this.$refs.areaOrderReport.handleExport()
//         break;
//       case '2':
//         this.$refs.areaGoodsReport.handleExport()
//         break;
//     }
//   }
  /**
   */
  showStartTimeDialog() {
    (this.$refs.datetimePicker as any).show();
  }
  showEndTimeDialog() {
    (this.$refs.endDateTimePicker as any).show();
  }
  updateEndTime(dateTime) {
    console.log('dateTime', dateTime);
    this.$set(this.searchTime, 'endTime', dateTime)
    console.log('endTime', this.searchTime.endTime);
    // this.endTime = dateTime;
    // console.log('endTime', this.endTime);
  }
  /**
   * @description: 获取期望交货日期
   * @param {*} dateTime
   * @return {*}
   */
  updateStartTime(dateTime) {
    console.log('dateTime', dateTime);
    // console.log('startTime', this.searchTime.startTime);
    this.$set(this.searchTime, 'startTime', dateTime)
    console.log('startTime', this.searchTime.startTime);
  }
  /**
   * @description 从订单详情返回刷新当前页数据，当前页之后的数据清除
   **/
  handleActivated() {
    const pageIndex =
      Math.trunc(this.clickedItemIndex / this.params.pageSize) + 1;
    const params = { ...this.params, pageIndex };
    getStoreOrder(params).then((res) => {
      if (pageIndex > 1) {
        const preData = this.goodsList.slice(
          0,
          (pageIndex - 1) * this.params.pageSize
        );
        const data = preData.concat(res.data.records);
        this.goodsList = JSON.parse(JSON.stringify(data));
      } else {
        this.goodsList = res.data.records;
      }
      this.params.pageIndex = pageIndex;
      if (Number(pageIndex) >= res.data.totalPages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    });
  }

  //   @Watch('tabKeys')
  //   handleTabKeys() {
  //     if (this.tabKeys === '-1') {
  //       this.params.orderStatus = '';
  //       this.params.payStatus = '';
  //     } else {
  //       if (this.tabKeys === '99') {
  //         this.params.payStatus = 0;
  //         this.params.orderStatus = '';
  //       } else {
  //         this.params.orderStatus = this.tabKeys;
  //         this.params.payStatus = '';
  //       }
  //     }
  //     this.params.pageIndex = 1;
  //     console.log('tabKeys', this.tabKeys, this.params.pageIndex);
  //     this.finished = false;
  //     this.loading = true;
  //     this.goodsList = [];
  //     if (this.controller) {
  //       console.log('123', this.controller);
  //       this.controller.abort();
  //     }
  //     this.getGoodsList();
  //   }

  /**
   * @description 关联退单
   *
   */
  //   goReturnList(list) {
  //     // 确保订单列表页面刷新
  //     this.$eventBus.$emit('refreshStatus', {
  //       status: '退款申请',
  //       orderId: list.orderId,
  //     });
  //   }

  searchGoods() {
    this.getGoodsList()
  }

  resetGoods() {
    this.getLastMonthDates()
  }

  getMoneyList() {
    statisticsByMoney({ storeId: this.companyId }).then((res) => {
      this.moneyList = res.data;
      console.log('moneyList', this.moneyList);
    })
  }

  getGoodsList() {
    statisticsByGoods({
      storeId: this.companyId,
      startTime: new Date(this.searchTime.startTime),
      endTime: new Date(this.searchTime.endTime)
    }).then(res => {
      console.log('goodsList', res.data);
      this.goodsList = res.data;
    })
    // this.error = false;
    // // if (this.params.orderStatus === 'undefined') return
    // this.controller = new AbortController();
    // const signal = this.controller.signal;
    // const res = {
    //   msg: '执行成功',
    //   code: '000000',
    //   data: {
    //     pageIndex: 1,
    //     pageSize: 20,
    //     records: [
    //       {
    //         storeName: '新的店铺',
    //         orderId: '1234567890',

    //         list: [
    //           { goodId: '11', goodName: '高山白萝卜', price: '7.00', num: '5' },
    //           { goodId: '22', goodName: '白萝卜', price: '3.00', num: '9' },
    //         ],
    //       },
    //       { storeName: '我的店铺', orderId: '987654321' },
    //     ],
    //     totalPages: 1,
    //     totalRecords: 5,
    //   },
    // };

    // const goodsList = this.goodsList.concat(res.data.records) || [];
    // this.goodsList = JSON.parse(JSON.stringify(goodsList));
    // console.log('goodsList', this.goodsList);
    // this.refreshing = false;
    // this.loading = false;

    // getStoreOrder({ ...this.params }, { signal })
    //   .then((res) => {
    //     this.error = false;
    //     if (this.refreshing) {
    //       this.goodsList = [];
    //     }

    //     res.data.records = [{}, {}];

    //     const goodsList = this.goodsList.concat(res.data.records) || [];
    //     this.goodsList = JSON.parse(JSON.stringify(goodsList));
    //     if (Number(this.params.pageIndex) >= res.data.totalPages) {
    //       console.log("123434---------");
    //       this.finished = true;
    //     } else {
    //       this.finished = false;
    //     }
    //   })
    //   .catch((err) => {
    //     this.error = true;
    //     this.params.pageIndex = 0;
    //   })
    //   .finally(() => {

    //   });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    console.log('onRefresh');
    // this.params.pageIndex = 1;
    this.refreshing = true;
    if (this.controller) {
      this.controller.abort();
    }
    this.getGoodsList();
    this.getMoneyList();
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    console.log('1234');
    // this.loading = true
    this.loading = false
    // this.params.pageIndex++;
    this.getGoodsList();
    this.getMoneyList();
  }
  showDetails(item) {
    this.dataDetail = item;
    this.showDetail = true;
  }

  //   showGoodsList(list: any) {
  //     (this.$refs.goodsList as any).showPop(list);
  //   }
}
